import planBase from "./planBase.js";
import imageFormat from "../../definition/imageFormat.js";
import filterBase from "./filter/filterBase.js";

export default class VideoPlan extends planBase {
    objectType = "VideoPlanItem";
    styleColor = '#2c5282'; // Bleu marine

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Video Plan";
    }

    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "video", description: "Changer la vidéo", svgComponentIcon: "playIcon" },
        ];
    }
    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "Video", description: "Changer la vidéo", svgComponentIcon: "playIcon" },
        ];
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Path", text: "Video", type: "pathInput", dataType: "string", ressourceType: "video" },
            { name: "Format", type: "selectInput", dataType: "number", options: imageFormat, optionsType: "idSoft" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput"),
            { name: "Filters", text: "Filtres", type: "arrayInput", dataType: "object", options: filterBase, elementOption: "compositionElement", label: "Ajouter un filtre à ", elements: { name: "Filters", type: "objectInput", dataType: "object", options: filterBase } },
        ];
    }

    getVideoStyle() {
        let style = {
            width: "100%",
            height: "100%"
        };
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (format) {
            style = format.action(style, "video");
        }
        else {
            style.objectFit = 'cover';
        }
        return style;
    }

    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
        }
        return style;
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            path: "@" + this._Path + "@",
            format: this.FormatName,
            filters: this.Filters,
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            path: this.Path,
            format: this.FormatName,
            filters: this.Filters,
        };
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Filters", construct: Array, jsType: "Array" },
            { property: "_Path", construct: String, jsType: "String", isRessource: true },
            { property: "Format", construct: Number, jsType: "Number" },
        ];
    }
}
